export const LANGUAGE_BUTTON_TYPES = {
    BUTTON: "button",
    MENU_ITEM: "menu-item",
    LINKS: "links"
}